import { Component, EventEmitter, Input, Output } from '@angular/core';
@Component({
  selector: 'app-csv-table',
  templateUrl: './csv-table.component.html',
  styleUrls: ['./csv-table.component.scss'],
})
export class CsvTableComponent {
  @Output() onSendGuestData = new EventEmitter();
  @Input() set csvData(val: any) {
    if (val) {
      this.dataSource = val;
      if (val.length > 0) {
        this.displayedColumns = Object.keys(val[0]);
        this.displayedColumns = this.displayedColumns.slice(
          0,
          this.displayedColumns.length - 1
        );
      }
    }
  }
  displayedColumns: string[] = [];
  dataSource: any[];
  editingCell: { row: any; column: string } = null;
  isEditingCell = false;
  itemEdited = '';

  onEnterKey(event: any, row: any, column: any) {
    // Prevent the default behavior of the Enter key (form submission)
    event.preventDefault();

    this.saveCell(row, column);
  }
  editingCellValue(val: any) {
    this.itemEdited = val;
  }
  editCell(row: any, column: string): void {
    this.editingCell = { row, column };
  }

  isEditing(row: any, column: string): boolean {
    return (
      this.editingCell &&
      this.editingCell.row === row &&
      this.editingCell.column === column
    );
  }
  saveCell(row: any, column: any): void {
    this.editingCell = null;
    this.dataSource.forEach((x) => {
      if (x.id == row.id) {
        x[column] = this.itemEdited;
      }
    });
  }
  cancelEdit(): void {
    this.editingCell = null;
  }
  sendGuestData() {
    this.onSendGuestData.emit(this.dataSource);
  }
}
